import React from 'react'
import { string, number } from 'prop-types'

function PromoteModelSelectedModelSection({
  itemTitle,
  itemSales,
  itemPrice,
  itemImage,
}) {
  return (
    <div className="promote-modal__section">
      <div className="promote-modal__section-header">
        <h3 className="promote-modal__section-title">Selected model</h3>
        <p className="promote-modal__section-description">
          Note: the model should not contain any branded or NSFW content
        </p>
      </div>
      <div className="promote-modal__model-card">
        <div className="promote-modal__model-preview">
          <div className="promote-modal__model-image-container">
            <img
              src={itemImage}
              alt={itemTitle}
              className="promote-modal__model-image"
            />
          </div>
          <div className="promote-modal__model-info">
            <h4 className="promote-modal__model-title">{itemTitle}</h4>
            <div className="promote-modal__model-stats">
              <span>{itemSales} total sales</span>
              <span>/</span>
              <span>${itemPrice}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

PromoteModelSelectedModelSection.propTypes = {
  itemTitle: string.isRequired,
  itemSales: number.isRequired,
  itemPrice: number.isRequired,
  itemImage: string.isRequired,
}

export default PromoteModelSelectedModelSection
